
import {stringToDigits} from './formatting';


export function codeValidation(testCode) {
	if(testCode === null) {
		return "Enter valid code";
	}
	let testLength = testCode.trim().length;
	if(testLength <= 0) {
		return "Enter valid code";
	}
	if(testLength > 16) {
		return "16 characters maximum";
	}
	return null;
}


export function nameValidation(testName) {
	if(testName === null) {
		return "Enter valid name";
	}
	let testLength = testName.trim().length;
	if(testLength <= 0) {
		return "Enter valid name";
	}
	if(testLength > 100) {
		return "100 characters maximum";
	}
	return null;
}

export function emailValidation(testEmail) {
	if(testEmail === null) {
		return "Enter valid email address";
	}
	let testLength = testEmail.trim().length;
	if(testLength <= 0) {
		return "Enter email address";
	}
	let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if(!re.test(testEmail)) {
  	return "Enter valid email";
  }
	return null;
}

export function phoneValidation(testPhone) {
	if(!testPhone) {
		return "Enter valid phone number";
	}
	let numberString = stringToDigits(testPhone);
	if(numberString.length != 10) {
		return "Phone numbers must have 10 digits";
	}
	return null;
}

export function passwordValidation(testPassword) {
	if(testPassword === null) {
		return "Enter valid password";
	}
	if(testPassword != testPassword.trim()) {
		return "Cannot begin or end with a space";
	}
	let testLength = testPassword.trim().length;
	if(testLength < 8) {
		return "Must be at least 8 characters";
	}
	return null;
}

export function messageTextValidation(messageText) {
	if(messageText === null || messageText === '') {
		return "Please enter a message";
	}
	let testLength = messageText.trim().length;
	if(testLength <= 0) {
		return "Please enter a message";
	}
	if(testLength > 65535) {
		return "It's a message, not a novel";
	}
	return null;
}



// WEBPACK FOOTER //
// ./src/utils/itemValidation.jsx